import { isSharedMailboxAutomapped } from 'owa-account-shared-mailbox-utils';
import { isSharedMailboxInfo } from 'owa-client-types/lib/SharedMailboxInfo';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { CalendarEntry } from 'owa-graph-schema';

export const isAutomappedCalendar = (calendar: CalendarEntry): boolean => {
    return (
        isGlobalFeatureEnabled('cal-leftnav-automapped-calendars') &&
        calendar.calendarId?.mailboxInfo &&
        isSharedMailboxInfo(calendar.calendarId.mailboxInfo) &&
        isSharedMailboxAutomapped(calendar.calendarId.mailboxInfo)
    );
};
